<!-- Adapted from https://github.com/timolins/react-hot-toast -->
<script lang="ts">
  import type { IconTheme } from "../core/types";

  interface Props {
    primary?: IconTheme["primary"];
    secondary?: IconTheme["secondary"];
  }

  let { primary = "#919191", secondary = "#e0e0e0" }: Props = $props();
</script>

<div style:--primary={primary} style:--secondary={secondary}></div>

<style>
  div {
    width: 24px;
    height: 24px;
    box-sizing: border-box;
    border: 4px solid;
    border-radius: 100%;
    border-color: var(--secondary, #e0e0e0);
    border-right-color: var(--primary, #919191);
    animation: rotate 1s linear infinite;
    margin: 3px;
  }

  @keyframes rotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>
